// Script to modify shopify-pc__banner__body-title element
(function () {
  "use strict";

  function modifyBannerTitle() {
    // Find the element by ID
    const bannerTitle = document.getElementById(
      "shopify-pc__banner__body-title",
    );

    if (bannerTitle) {
      // Add the 'text-lg' and 'bold' classes
      bannerTitle.classList.add("text-lg", "bold");

      // Check if it's an h2 tag and change it to a p tag
      if (bannerTitle.tagName.toLowerCase() === "h2") {
        // Create new p element
        const newPElement = document.createElement("p");

        // Copy all attributes from h2 to p
        for (let i = 0; i < bannerTitle.attributes.length; i++) {
          const attr = bannerTitle.attributes[i];
          newPElement.setAttribute(attr.name, attr.value);
        }
        // Copy inner HTML
        newPElement.innerHTML = bannerTitle.innerHTML;
        // Replace h2 with p
        bannerTitle.parentNode.replaceChild(newPElement, bannerTitle);
      }
    }
  }

  // Run immediately if DOM is already loaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", modifyBannerTitle);
  } else {
    modifyBannerTitle();
  }

  // Also run on window load as a fallback
  window.addEventListener("load", modifyBannerTitle);

  // Fire the cart page Floodlight pixel once, only when the cart drawer opens.
  // This matches the theme's dialog lifecycle, which uses dialog:before-show.
  function attachCartDrawerPixel() {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer || window.__dv360CartPixelFired) {
      return;
    }

    cartDrawer.addEventListener("dialog:before-show", function () {
      if (window.__dv360CartPixelFired) {
        return;
      }

      window.__dv360CartPixelFired = true;

      if (typeof gtag === "function") {
        gtag("event", "conversion", {
          allow_custom_scripts: true,
          send_to: "DC-16952720/invmedia/beaub000+standard",
        });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachCartDrawerPixel);
  } else {
    attachCartDrawerPixel();
  }
})();
